import { VehicleOemDataGroupDtoResponse } from './vehicule-oem-data-group.dto-response';

export class VehicleOemDataDtoResponse {
  groups: VehicleOemDataGroupDtoResponse[];
  premiumGroups: VehicleOemDataGroupDtoResponse[];
  isStaggered: boolean;
  isTPMSEquipped: boolean;
  boltNut: string;

  // djb:stakeholder priority
  conversionToolTipFront: string;
  conversionToolTipRear: string;

  engine: string;
  drivetrainType: string;
  bodyStyle: string;
  bedLength: string;
  brakeTypeFR: string;
  generation: string;
  notes: string;
  internalNotes: string;
}
